<div class="container h-screen overflow-hidden">
  <penji-header></penji-header>
  <div class="overflow-auto" style="height: calc(100% - 52.8px);">
    <router-outlet></router-outlet>
  </div>
</div>
